document.addEventListener("alpine:init", () => {
    Alpine.data("timetableGrid", (dates, timetable, clubs, activityCategories, defaultClub) => ({
        dates: dates || [],
        timetable: timetable,
        displayedDates: [],
        filteredTimetable: timetable,
        startIndex: 0,
        maxDisplay: 4,
        clubs: clubs,
        activityCategories: activityCategories,
        selectedClubId: null,
        defaultClubName: null,
        selectedActivityCategoryId: null,
        selectedServiceName: 'Types',
        showMoreFilters: false,
        showActivityFilters: false,
        activeDate: null,
        loading: false,
        hasResults: false,

        init() {
            if (!this.dates || this.dates.length === 0) {
                console.error('No dates provided.');
                return;
            }

            if (defaultClub) {
                this.selectedClubId = defaultClub.id;
                this.selectedClubName = this.defaultClubName = defaultClub.name;
            } else {
                console.error('No default club provided.');
                return;
            }

            this.updateDisplayedDates();
            this.checkUrlParams();
            this.updateHasResults();

            if (this.displayedDates.length > 0) {
                this.setActiveDate(this.displayedDates[0]);  // Set the first displayed date as active
            }
        },

        updateDisplayedDates() {
            this.displayedDates = this.dates.slice(this.startIndex, this.startIndex + this.maxDisplay);
        },

        checkUrlParams() {
            const params = new URLSearchParams(window.location.search);

            if (params.has('location_id')) {
                this.selectedClubId = params.get('location_id');
            }

            if (params.has('activity_category_id')) {
                this.selectedActivityCategoryId = params.get('activity_category_id');
            }

            this.setClubName();
            this.setServiceName(); // Set the activity category name if activity_category_id is present
        },


        setClubName() {
            const selectedClub = this.clubs.find(club => club.id == this.selectedClubId);
            this.selectedClubName = selectedClub ? selectedClub.name : this.defaultClubName;
        },

        setServiceName() {
            const selectedService = this.activityCategories.find(service => service.id == this.selectedActivityCategoryId);
            this.selectedServiceName = selectedService ? selectedService.name : 'Types';
        },

        filterByLocation(clubId) {
            this.selectedClubId = clubId;
            this.setClubName();

            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('location_id', clubId);

            // Preserve the existing activity_category_id filter, if any
            if (this.selectedActivityCategoryId) {
                currentUrl.searchParams.set('activity_category_id', this.selectedActivityCategoryId);
            }

            this.showMoreFilters = false; // Close the club filter dropdown

            // Start loading state
            this.loading = true;

            // Update the page with the new filters
            pegasus.ajaxContent(currentUrl.toString(), ['data-timetable'], {}, () => {
                // End loading state
                this.loading = false;
                this.updateHasResults();
            });
        },

        filterByActivity(activityCategoryId) {
            this.selectedActivityCategoryId = activityCategoryId;
            this.setServiceName();

            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('activity_category_id', activityCategoryId);

            // Preserve the existing location_id filter, if any
            if (this.selectedClubId) {
                currentUrl.searchParams.set('location_id', this.selectedClubId);
            }

           if (this.displayedDates) {
               // get the first date from displayed dates
               const firstDate = this.displayedDates[0];
               currentUrl.searchParams.set('fromDate', firstDate);
               // get the last date
               const lastDate = this.displayedDates[this.displayedDates.length - 1];
               currentUrl.searchParams.set('toDate', lastDate);
               // and pass them in url
           }

            this.showActivityFilters = false; // Close the activity filter dropdown

            // Start loading state
            this.loading = true;

            // Update the page with the new filters
            pegasus.ajaxContent(currentUrl.toString(), ['data-timetable'], {}, () => {
                // End loading state
                this.loading = false;
                this.updateHasResults();
            });
        },

        updateTimetable() {
            const params = new URLSearchParams(window.location.search);

            if (this.selectedClubId) {
                params.set('location_id', this.selectedClubId);
            } else {
                params.delete('location_id');
            }

            if (this.selectedActivityCategoryId) {
                params.set('activity_category_id', this.selectedActivityCategoryId);
            } else {
                params.delete('activity_category_id');
            }

            window.location.search = params.toString(); // Update the URL with new parameters
            // Note: hasResults will be updated after the page reloads
        },

        updateDates(fromDate, daysInView) {
            const daysToFetch = 3;
            const toDate = new Date(fromDate);
            toDate.setDate(toDate.getDate() + daysToFetch);

            const formattedFromDate = fromDate.toISOString().split('T')[0];
            const formattedToDate = toDate.toISOString().split('T')[0];

            const params = new URLSearchParams(window.location.search);
            params.set('fromDate', formattedFromDate);
            params.set('toDate', formattedToDate);

            this.displayedDates = Array.from({ length: daysInView }, (_, i) => {
                const date = new Date(fromDate);
                date.setDate(date.getDate() + i);
                return date.toISOString().split('T')[0];
            });

            // Preserve existing filters
            if (this.selectedClubId) {
                params.set('location_id', this.selectedClubId);
            }
            if (this.selectedActivityCategoryId) {
                params.set('activity_category_id', this.selectedActivityCategoryId);
            }

            // Start loading state
            this.loading = true;

            // Update the URL and content
            const newUrl = new URL(window.location.href);
            newUrl.search = params.toString();

            pegasus.ajaxContent(newUrl, ['data-timetable'], {}, () => {
                this.loading = false;
                this.setActiveDate(this.displayedDates[0]);
                this.updateHasResults();
            });
        },

        nextDates(daysInView, selectedDate = null) {
            const currentFirst = this.displayedDates[0];
            const currentFirstDate = new Date(currentFirst);
            const nextFromDate = selectedDate ? new Date(selectedDate) : new Date(currentFirstDate);
            nextFromDate.setDate(nextFromDate.getDate() + (selectedDate ? 0 : daysInView));

            this.updateDates(nextFromDate, daysInView);
        },

        prevDates(daysInView) {
            const currentStart = new Date(this.displayedDates[0]);
            const prevFromDate = new Date(currentStart);
            prevFromDate.setDate(prevFromDate.getDate() - daysInView);
        
            const today = new Date();
            today.setHours(0, 0, 0, 0);
        
            if (prevFromDate < today) {
                this.updateDates(today, daysInView);
            } else {
                this.updateDates(prevFromDate, daysInView);
            }
        },           

        goToToday(daysInView) {
            const today = new Date();
            this.updateDates(today, daysInView);
        },

        setActiveDate(date) {
            this.activeDate = date;
            this.updateActiveClass();
            this.scrollToColumn(date);
        },

        goToDate(date) {
            this.nextDates(4, date);
        },

        removeActiveDate(date) {
            if (this.activeDate === date) {
                this.activeDate = null;
            }
            this.updateActiveClass();
        },

        updateActiveClass() {
            document.querySelectorAll('.Timetable__DateItem').forEach(item => {
                item.classList.remove('active');
            });
            if (this.activeDate) {
                const activeDateElement = document.querySelector(`.Timetable__DateItem[data-date='${this.activeDate}']`);
                if (activeDateElement) {
                    activeDateElement.classList.add('active');
                }
            }
        },

        scrollToColumn(date) {
            const column = document.querySelector(`.Timetable__DayColumn[data-column='${date}']`);
            if (column) {
                const container = document.querySelector('.Timetable__GridRow');
                if (container) {
                    // Calculate the distance from the left edge of the container to the column
                    const scrollPosition = column.offsetLeft - container.offsetLeft;

                    // Adjust the scroll to ensure it moves to the correct position
                    container.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth'
                    });
                }
            }
        },
        updateHasResults() {
            this.hasResults = Object.keys(this.timetable).length > 0;
        },
    }));
});